import {
    GenericItemsUtils,
    IGetAllParams,
    GenericItemsForm,
    BaseGenericItemsStore,
    MuiDataGrid,
    MuiIcons
} from "@leap4/frontend";
import {AlertsBaseUrl} from "../../../../config/generals";
import {urlService} from "../../../routing/urlsService";
import {Link} from "react-router-dom";
import {DateTime} from "luxon";
import {parseExpression} from "cron-parser"
import {RootState} from "../../../../interfaces/root-state.interface";
import {connect, ConnectedProps} from "react-redux";
type GridColDef = MuiDataGrid.GridColDef;
type GridRenderCellParams = MuiDataGrid.GridRenderCellParams;
const { AlarmOn } = MuiIcons;

const fields = {
    name: 1,
    type: 1,
    intervalHour: 1,
    lastRun: 1,
    cronExpression:1,
    group: 1,
    isActive:1
}


const getParams: IGetAllParams = {
    fields,
    populate: [
        {path: "group", select: {name: 1}},
    ]
}


let columns: GridColDef[];
let store: BaseGenericItemsStore<{ _id: string, isActive: boolean }>

function setStoreAndColumns() {
    const storeAndColumns = GenericItemsUtils.GenerateDefaultStoreAndColumns({
        baseUrl: `${AlertsBaseUrl}`
    }, fields, {
        name: {editLinkFunc: (id: string) => urlService.editAlert(id)},
        isActive: {},
        updated: {},
        created: {}
    })

    store = storeAndColumns.store;
    columns = storeAndColumns.columns;

    const nameCol = columns.find(x => x.field === "name");
    nameCol.renderCell = (params: GridRenderCellParams) =>
        <Link to={urlService.editAlert(params.id.toString())}><strong
        >{params.value}</strong></Link>


    const typeCol = columns.find(x => x.field === "type");
    typeCol.renderCell = (params: GridRenderCellParams) => params.value

    const cronExpressionCol = columns.find(x => x.field === "cronExpression");
    cronExpressionCol.renderCell = (params: GridRenderCellParams) => params.value

    const intervalCol = columns.find(x => x.field === "intervalHour");
    intervalCol.renderCell = (params: GridRenderCellParams) => params.value


    const lastRunCol = columns.find(x => x.field === "lastRun");
    lastRunCol.renderCell = (params: GridRenderCellParams) => {
        const date = new Date(params.value as Date);
        return date.toLocaleString('en-GB')
    }

    const nextRunGetter = (params) => {
        const cronExpression:string = params.row[cronExpressionCol.field]
        if (cronExpression){
            return new Date(parseExpression(cronExpression).next().toISOString()).toLocaleString('en-GB')
        }
        const intervalHour:number = params.row[intervalCol.field]
        const lastRun = DateTime.fromJSDate(new Date(params.row[lastRunCol.field])).toUTC()
        const nextRun = lastRun.plus({hours: intervalHour}).toUTC().toJSDate()
        return new Date(nextRun).toLocaleString('en-GB')
    };
    const nextRun: GridColDef = {field:"nextRun", headerName:"NEXTRUN", width: 220}
    columns.push(nextRun)
    nextRun.valueGetter = nextRunGetter

    const nextRunCol = columns.find(x => x.field === "nextRun");
    nextRunCol.renderCell = (params: GridRenderCellParams) => {
        return params.value
    }

    const groupNameCol = columns.find(x => x.field === "group");
    groupNameCol.renderCell = (params: GridRenderCellParams) => (params.value as any).name

    columns = columns.filter(col => (col.field !== "intervalHour" && col.field !== "cronExpression"))
}
const mapStateToProps = (state: RootState) => ({
    selectedOrganization: state.auth.selectedOrganizationId
});


const connector = connect(mapStateToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;
const AlertsDashboardModule = (props:PropsFromRedux) => {
    setStoreAndColumns();

    return (
            <GenericItemsForm
                organization={props.selectedOrganization}

                columns={columns}
                store={store}
                breadcrumbs={{
                    link: urlService.alerts(),
                    text: "Alerts Dashboard",
                    icon: <AlarmOn />
                }}
                tableProps={{pageSize: 100, style: {minHeight: "75vh"}}}
                getAllParams={getParams}
                createButton={{
                    text: "Create Alert",
                    to: urlService.createAlert()
                }
                }
            />
    );
};


export default connector(AlertsDashboardModule);